export const USER_QUERY_KEYS = {
  getUserInfo: "get:/v1/user/info",
  getUserInfoMe: "get:/v1/users/me",
};
